import VueRouter from 'vue-router'
import Dashboard from './../components/Dashboard'
import Email from './../components/Email'
import Peek from './../components/Peek'
import Company from './../components/Company'
import Product from './../components/Product'
import EmailBodyPopUp from './../components/EmailBodyPopUp'
import Deduplicate from './../components/Deduplicate'
import ManagePdf from './../components/ManagePdf'
import ErrorPage from './../components/ErrorPage'
import ViewProduct from './../components/ViewProduct'
import MobilePreview from './../components/MobilePreview'
import EmailEditor from '../components/EmailEditor.vue'



const routes = [

  {
    path: '/', component: Dashboard, name: 'home', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/email/:muid', component: Email, name: 'email', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
{
  path: '/emailEditor/:muid', component: EmailEditor, name: 'emailEditor', props: true, meta: {
    title: 'Content Portal - Competiscan.com',
  }
},

  {
    path: '/spaceyemail/:muid', component: Email, name: 'spaceyemail', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/peek/:muid', component: Peek, name: 'peek', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/visualize/:muid', component: Peek, name: 'visualize', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/company/:muid', component: Company, name: 'company', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/spacy', component: Dashboard, name: 'spacy', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/companynew/:muid', component: Company, name: 'companynew', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/companynew1/:muid', component: Company, name: 'companynew1', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/emailbodypopup/:muid/:emaildate', component: EmailBodyPopUp, name: 'emailbodypopup', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/deduplicates', component: Deduplicate, name: 'Deduplicate', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/producer', component: Dashboard, name: 'producer', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/consumer', component: Dashboard, name: 'consumer', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/mortgage', component: Dashboard, name: 'mortgage', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/provider', component: Dashboard, name: 'provider', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  // {
  //   path: '/addproduct/:muid', component: Product, name: 'addproduct', props: true, meta: {
  //     title: 'Content Portal - Competiscan.com',
  //   }
  // },
  {
    path: '/addproduct', component: Product, name: 'addproduct', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/product/:muid', component: Product, name: 'product', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/product', component: Product, name: 'product', props: true,
    meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/addproduct/v2/:muid', component: Product, name: 'addproduct-v2', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/addproduct/v2', component: Product, name: 'addproduct-v2', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/product/v2/:muid', component: Product, name: 'product-v2', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/product/v2', component: Product, name: 'product-v2', props: true,
    meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/viewproduct/:muid', component: ViewProduct, name: 'addproduct', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/managepdf/:product_id', component: ManagePdf, name: 'ManagePdf', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/errorpage', component: ErrorPage, name: 'ErrorPage', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },
  {
    path: '/mobilepreview/:product_id', component: MobilePreview, name: 'MobilePreview', props: true, meta: {
      title: 'Content Portal - Competiscan.com',
    }
  },

]

// export router view

export default new VueRouter({
  hashbang: false,
  mode: 'history',
  routes
})
